// Sound utilities for the Forms Studio application

// Create audio context for sound effects
let audioContext = null;

// Initialize audio context (needed for modern browsers)
const initAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
};

// Play a success sound when CSV is imported
export const playCSVImportSound = () => {
  try {
    // Create audio element for the MP3 file
    const audio = new Audio("/wistful-1-39105.mp3");

    // Set volume to a reasonable level (0.0 to 1.0)
    audio.volume = 0.6;

    // Play the sound
    audio.play().catch((error) => {
      console.warn("Could not play MP3 sound effect:", error);
    });
  } catch (error) {
    console.warn("Could not play sound effect:", error);
  }
};

// Play a notification sound (alternative)
export const playNotificationSound = () => {
  try {
    const ctx = initAudioContext();

    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    // A gentle notification sound
    oscillator.type = "triangle";
    oscillator.frequency.setValueAtTime(800, ctx.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(
      400,
      ctx.currentTime + 0.2
    );

    gainNode.gain.setValueAtTime(0, ctx.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.2, ctx.currentTime + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.3);
  } catch (error) {
    console.warn("Could not play notification sound:", error);
  }
};

// Play a sound when JSON is downloaded
export const playJSONDownloadSound = () => {
  try {
    // Create audio element for the MP3 file
    const audio = new Audio("/awesome-level-up-351714.mp3");

    // Set volume to a reasonable level (0.0 to 1.0)
    audio.volume = 0.6;

    // Play the sound
    audio.play().catch((error) => {
      console.warn("Could not play JSON download sound effect:", error);
    });
  } catch (error) {
    console.warn("Could not play JSON download sound effect:", error);
  }
};



// Cleanup function
export const cleanupAudioContext = () => {
  if (audioContext) {
    audioContext.close();
    audioContext = null;
  }
};
